import operations, { OperationResources } from './operations';
import tasks, { TaskResources } from './tasks';

export default {
    ...operations,
    ...tasks,
};

export type Resources = OperationResources & TaskResources;
